module.exports = __webpack_public_path__ + "img/xactus_logo.c7a7ae7f.png";